<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('Browsing History')" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        <div class="common-btn btn" slot="right" @click="clearallBrowse()">{{ $t('Clear browsing history') }}</div>
      </mt-header>
    </div>
    <div class="browse-wrapper">
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="list-wrapper main-content" v-if="goodsbrowse_list && goodsbrowse_list.length">
          <div class='browse-item' v-for="(item, index) in goodsbrowse_list" v-bind:key="index">
            <div class='title'>{{ item.time }}</div>
            <div class='goods_list'>
              <div class='goods-item' v-for="(goods, i) in item.goods_list" v-bind:key="i">
                <div class='img'><img class="image" :src="goods.goods_image_url" /></div>
                <div class='price'>${{ goods.goods_promotion_price }}</div>
              </div>
            </div>
          </div>
        </div>
        <empty-record v-else-if="goodsbrowse_list && !goodsbrowse_list.length"></empty-record>
      </div>
    </div>
  </div>
</template>

<script>
import { getBrowseList, clearallBrowse } from '../../../api/memberBrowse'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
    EmptyRecord
  },
  data() {
    return {
      params: { 'page': 0, 'per_page': 4 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      goodsbrowse_list: false
    }
  },
  created() {

  },
  methods: {
    // 清空浏览记录
    clearallBrowse() {
      clearallBrowse(this.params).then(res => {
        this.goodsbrowse_list = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    goGoods(goods_id) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': goods_id } })
    },
    loadMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getBrowseList(true)
      }
    },
    getBrowseList() {
      Indicator.open()
      getBrowseList(this.params).then(res => {
        Indicator.close()
        if (res) {
          if (res.result.hasmore) {
            this.isMore = true
          } else {
            this.isMore = false
          }
          let temp = res.result.goodsbrowse_list
          if (temp) {
            if (!this.goodsbrowse_list) {
              this.goodsbrowse_list = temp
            } else {
              this.goodsbrowse_list = this.goodsbrowse_list.concat(temp)
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.common-header {
  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

}

.main-content {
  background: #fff;
  padding: 0 $pageSpace;
  box-sizing: border-box;
}

// .browse-wrapper .browse-item{}
.browse-wrapper .browse-item .title {
  color: #333;
  font-size: .8rem;
  font-weight: bold;
  padding-top: .5rem;
}

.browse-wrapper .browse-item .goods_list {
  padding-top: .5rem;
  display: flex;
  flex-wrap: wrap;
}

.browse-wrapper .browse-item .goods_list .goods-item {
  width: 32%;
  margin-right: 1%;
  margin-bottom: .5rem;
}

.browse-wrapper .browse-item .goods_list .goods-item .img {
  border-radius: .5rem;
  overflow: hidden;
}

.browse-wrapper .browse-item .goods_list .goods-item .img img {
  width: 100%;
  height: 100%;
}

.browse-wrapper .browse-item .goods_list .goods-item .price {
  font-size: .8rem;
  color: $primaryColor;
  padding: .5rem 0;
  text-align: center;
}
</style>
